import { GzCollapsiblePanelWebComponent } from './component/GzCollapsiblePanelWebComponent';

export { GzCollapsiblePanelWebComponent };
